import {useState,type FormEvent} from 'react';

/** A regular account action. Never requested automatically at first login. */
export function ChangePasswordPanel(){
  const [open,setOpen]=useState(false);
  const [current,setCurrent]=useState('');
  const [next,setNext]=useState('');
  const [busy,setBusy]=useState(false);
  const [message,setMessage]=useState('');
  const submit=async(e:FormEvent<HTMLFormElement>)=>{
    e.preventDefault();
    if(busy||!current||next.length<6)return;
    setBusy(true);setMessage('');
    try{
      const response=await fetch('/api/v1/auth/change-password',{
        method:'POST',credentials:'same-origin',cache:'no-store',
        headers:{'Content-Type':'application/json'},
        body:JSON.stringify({currentPassword:current,newPassword:next}),
      });
      if(!response.ok){
        setMessage(response.status===401?'Current password is incorrect or the session has expired.':
          'Unable to change password. Please try again.');
        return;
      }
      setCurrent('');setNext('');
      setMessage('Password changed successfully.');
    }catch{setMessage('Unable to change password. Please try again.');}
    finally{setBusy(false);}
  };
  return <div className="ecfs-change-password">
    <button type="button" onClick={()=>{setOpen(v=>!v);setMessage('');}}>
      {open?'Close Change Password':'Change Password'}
    </button>
    {open&&<form onSubmit={event=>void submit(event)} aria-label="Change Password">
      <label>Current password
        <input type="password" autoComplete="current-password"
          required value={current} onChange={event=>setCurrent(event.target.value)}/>
      </label>
      <label>New password
        <input type="password" autoComplete="new-password" required minLength={6}
          value={next} onChange={event=>setNext(event.target.value)}/>
      </label>
      <button type="submit" disabled={busy}>{busy?'Saving…':'Save Password'}</button>
    </form>}
    {message&&<p role="status">{message}</p>}
  </div>;
}
